import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { useEntityIdParam } from '../../hooks/useEntityIdParam';
import { useSMLDatePickerDateParam } from '../../hooks/useSMLDatePickerDateParam';
import { useSMLCountryParam } from '../../hooks/useSMLCountryParam';
import { useTrackPlaylistScoreChart } from '../../hooks/useTrackPlaylistScoreChart';
import { PlaylistScoreChart } from '../PlaylistScoreChart/PlaylistScoreChart';

interface TrackPlaylistScoreChartProps {
  // No props needed - component will use hooks directly
}

const TrackPlaylistScoreChartComponent: React.FC<TrackPlaylistScoreChartProps> = () => {
  const intl = useIntl();
  const trackId = useEntityIdParam('track');
  const { selectedDate, rangeDays } = useSMLDatePickerDateParam();
  const { countryCode } = useSMLCountryParam();

  const {
    data: scoreData,
    isLoading,
    error,
  } = useTrackPlaylistScoreChart({
    trackId: trackId || '',
    date: selectedDate,
    rangeDays,
  });

  const data = React.useMemo(() => scoreData?.data || [], [scoreData?.data]);
  const dateRange = scoreData?.dateRange;

  const title = intl.formatMessage({
    id: 'app.sml.track.details.playlist-score',
    defaultMessage: 'Playlist Score',
  });

  return (
    <>
      <PlaylistScoreChart title={title} data={data} dateRange={dateRange} isLoading={isLoading} error={error} />
      {countryCode !== undefined && (
        <span className="text-muted small">
          {intl.formatMessage({
            id: 'app.sml.track.details.scoreChartGlobalNote',
            defaultMessage: 'Score is calculated worldwide',
          })}
        </span>
      )}
    </>
  );
};

export const TrackPlaylistScoreChart = TypedMemo(TrackPlaylistScoreChartComponent);
